<template>
    <div>
        <v-select :id="`div_`+name"
                  v-model="internalValue"
                  :filterable="true"
                  :name="`div_`+name"
                  :options="selectOptions"
                  :reduce="option => option.id"
                  class="style-chooser"
                  label="name">
            <template slot="no-options">
                Start typing to search...
            </template>
        </v-select>

        <input :id="name" v-model="internalValue" :name="name" type="hidden">
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: "SelectBooleanComponent",
    components: {vSelect},
    props: {
        initialValue: {
            default: 0
        },
        name: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            internalValue: null,
            selectOptions: [
                {
                    id: 1,
                    name: 'Yes',
                },
                {
                    id: 0,
                    name: 'No',
                },
            ],
        }
    },
    watch: {
        internalValue(val) {
            this.$emit("onSelect", this.internalValue, this.index);
        }
    },
    methods: {
        clearValue() {
            this.initialValue = null;
        }
    },
    mounted() {
        this.internalValue = parseInt(this.initialValue);
        this.$forceUpdate();

    },
}
</script>

<style scoped>

</style>
